/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorWorkspaceApproveLogDto } from '../../models/vendor-workspace-approve-log-dto';

export interface VendorWorkspaceApproveLogControllerDelete$Params {
  id: string;
}

export function vendorWorkspaceApproveLogControllerDelete(http: HttpClient, rootUrl: string, params: VendorWorkspaceApproveLogControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceApproveLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceApproveLogControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceApproveLogDto>;
    })
  );
}

vendorWorkspaceApproveLogControllerDelete.PATH = '/api/vendorWorkspaceApproveLog/{id}';
